module.exports = __webpack_public_path__ + "img/erweima.df6f39ad.png";